import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import * as React from 'react';
import classNames from 'classnames';
import { debounce, uniq, words, escape } from 'lodash-es';
import { toggleToast } from '../../../toast/index.js';
import '../../../utils/fetcher.js';
import { prependPrefix } from '../../../utils/style.js';
import { getSoundSearchSuggest } from '../../api/index.js';
import { SEARCH_ITEM_CLASSNAME, SEARCH_KEYWORD_CLASSNAME } from '../utils/index.js';
import { SuggestionList } from './suggestion-list.js';
import { getSearchType } from '../utils/suggest.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var initialState = {
  active: -1,
  keyword: '',
  keywordList: []
};
var DEBOUNCE_TIME = 500;
var SearchSuggest = /*#__PURE__*/function (_SuggestionList) {
  _inherits(SearchSuggest, _SuggestionList);

  var _super = _createSuper(SearchSuggest);

  function SearchSuggest(props) {
    var _this;

    _classCallCheck(this, SearchSuggest);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "handleKeywordChange", function (keyword) {
      if (!keyword) {
        _this.setState(_objectSpread({}, initialState));
      } else if (keyword !== _this.state.keyword && _this.mounted) {
        // TODO: 去掉 as，优化 getSearchType 返回类型
        var type = getSearchType(_this.props.type === 'large');

        _this.loadKeyword(keyword, type);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadKeyword", debounce(function (keyword, type) {
      _this.setState({
        keyword: keyword,
        keywordList: []
      });

      getSoundSearchSuggest(keyword, type).then(function (res) {
        if (_this.state.keyword === keyword && _this.mounted) {
          _this.setState({
            active: -1,
            keywordList: res.info || []
          });
        }
      }).catch(function (error) {
        toggleToast((error === null || error === void 0 ? void 0 : error.message) || '未知错误');
      });
    }, DEBOUNCE_TIME));

    _defineProperty(_assertThisInitialized(_this), "handleClickKeyword", function (keyword, e) {
      if (_this.props.type !== 'large') {
        return;
      }

      e.preventDefault();

      _this.setState(_objectSpread({}, initialState));

      _this.submit(keyword);
    });

    _this.state = _objectSpread({}, initialState);
    _this.containerRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(SearchSuggest, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.addKeydownListener();
      this.handleKeywordChange(this.props.keyword);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevKeyword = prevProps.keyword;
      var nextKeyword = this.props.keyword;

      if (prevKeyword !== nextKeyword) {
        this.handleKeywordChange(nextKeyword);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.removeKeydownListener();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var type = this.props.type;
      var _this$state = this.state,
          _this$state$keyword = _this$state.keyword,
          keyword = _this$state$keyword === void 0 ? '' : _this$state$keyword,
          keywordList = _this$state.keywordList,
          active = _this$state.active;
      var isLargeType = type === 'large';

      if (!keywordList.length) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: prependPrefix('search-suggestion')
      }, /*#__PURE__*/React.createElement("span", {
        className: "suggestion-title"
      }, "\u5173\u952E\u8BCD"), /*#__PURE__*/React.createElement("ul", {
        className: "suggestion-content",
        ref: this.containerRef
      }, _mapInstanceProperty(keywordList).call(keywordList, function (word, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: word,
          title: word,
          onClick: _this2.handleClickKeyword.bind(_this2, word),
          className: classNames(SEARCH_ITEM_CLASSNAME, {
            active: active === i
          })
        }, /*#__PURE__*/React.createElement("a", {
          className: SEARCH_KEYWORD_CLASSNAME,
          target: isLargeType ? '' : '_blank',
          href: isLargeType ? '' : SuggestionList.getSearchLink(word),
          // eslint-disable-next-line @typescript-eslint/naming-convention
          dangerouslySetInnerHTML: {
            __html: SearchSuggest.formatHighlightedKeyword(word, keyword)
          }
        }));
      })));
    }
  }], [{
    key: "getKeywordRegExp",
    value: function getKeywordRegExp(keyword) {
      var keywordList = keyword.match(/([0-9]+|[a-zA-Z]+|.)/g) || []; // 去除标点符号或特殊符号

      var uniqKeywordList = uniq(words(keywordList.join(',')));
      return new RegExp("(".concat(uniqKeywordList.join('|'), ")"), 'gi');
    }
  }, {
    key: "formatHighlightedKeyword",
    value: function formatHighlightedKeyword(word, keyword) {
      return word.replace(SearchSuggest.getKeywordRegExp(keyword), function (hightlightedKeyword) {
        return "<span class=\"hightlighted-keyword\">".concat(escape(hightlightedKeyword), "</span>");
      });
    }
  }]);

  return SearchSuggest;
}(SuggestionList);

export { SearchSuggest };
